import React from 'react'

import NavLink from '../../Routes/NavLink';

export default class CancelledTransactionsCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            totalCancelledTransactionAmount: 0
        };
    }

    componentDidMount() {
        //Waiting for API
    }

    render() {
        const totalCancelledTransactionAmount = this.state.totalCancelledTransactionAmount;
        return (
            <div class="col-md-3 col-sm-6 col-xs-12">
                <div class="info-box">
                    <span class="info-box-icon red-icon-circle"><i class="icon-money-arrow"></i></span>
                    <div class="info-box-content">
                        <span class="info-box-text">Cancelled</span>
                        <br/>
                        <span class="info-box-subtext">Total amount of cancelled transactions</span>
                        <span class="info-box-number red-info-number">${totalCancelledTransactionAmount}</span>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Admin/Transactions/CancelledTransactionsCard.jsx